import * as React from 'react';

import * as styles from './MobilePadding.scss';

export default function MobilePadding({children}: {children: React.ReactNode}) {
  return <div className={styles.MobilePadding}>{children}</div>;
}
